<template>
  <d-datepicker
    :id="dateFieldId"
    small
    v-model="dateMapper"
    :input-class="inputClasses"
    :format="format"
    :placeholder="placeholder"
    :minimumView="minimumView"
    :maximumView="maximumView"
    :disabled="disabled"
    :language="ptBR"
    :use-utc="true"
    :disabledDates="disabledDates"
    @input="change()"
  />
</template>

<script>
import { en, es, ptBR } from "vuejs-datepicker/dist/locale";
import { generateGuid } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "date-field",
  components: {
    dateField,
  },
  data() {
    return {
      en,
      es,
      ptBR,
      disabledDates: {
        days: this.getWeekendDates(),
        to: this.getMinDate()
      },
      dateFieldId: generateGuid()
    };
  },
  props: {
    inputClass: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: "2000-00-00T00:00:00"
    },
    format: {
      type: String,
      default: "dd/MM/yyyy"
    },
    placeholder: {
      type: String,
      default: ""
    },
    minDate: {
      default: null
    },
    minimumView: {
      type: String,
      default: "day"
    },
    maximumView: {
      type: String,
      default: "year"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledWeekend: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Adjusting field 'CSS' stuffs because 'typeable' prop isn't working:
    // https://github.com/charliekassel/vuejs-datepicker/issues/733
    $(`#${this.dateFieldId}`).attr("readonly", false);
    $(`#${this.dateFieldId}`).keypress(function(e) {e.preventDefault();});
    if (!this.disabled) {
      $(`#${this.dateFieldId}`).css('cursor', 'pointer');
    }
    $(`#${this.dateFieldId}`).on('focus', function(e) {
      e.preventDefault();
      $(this).blur();
    });
  },
  model: {
    event: `modified`
  },
  methods: {
    changeValue(newVal) {
      this.$emit("modified", newVal);
    },
    change() {
      this.$emit("change");
    },
    getMinDate: function() {
      if (this.minDate != null && this.minDate != undefined)
        return new Date(new Date(this.minDate) - 8640000);
      return undefined;
    },
    getWeekendDates: function() {
      if (this.disabledWeekend) return [6, 0];
      return undefined;
    }
  },
  computed: {
    inputClasses() {
      return this.inputClass + " form-control";
    },
    dateMapper: {
      get() {
        if (this.value != null) {
          let date = new Date(this.value).toISOString().substring(0, 10);
          return date;
        }
        return null;
      },
      set(value) {
        if (value != null) {
          let date = new Date(value).toJSON().substring(0, 10);
          this.changeValue(date);
        }
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/date-field.vue